import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import Heading from '@tds/core-heading';
import DimpleDivider from '@tds/core-dimple-divider';
import Spinner from '@tds/core-spinner';

import request from '../../utils/request';

import { ContentWrapper, Box, TopbarWrapper } from '../../design/css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { orderStatus } from '../../utils/constant';
import { getFormattedDate } from '../../utils/utils';

import Table from './Table';
import Pagination from './Pagination';
import SearchBar from './components/searchBar';
import Filters from './components/filters';
import Analytics from './components/analytics';
import ExportReport from './components/exportReport';

const IotOrderFulfillmentDashboard = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { noOrders }
  } = localizedStrings;
  const [ordersList, setOrdersList] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [pageLoading, setPageLoading] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [filters, setFilters] = useState({
    iotProductSelected: '',
    status: '',
    flag: '',
    assignedUserId: '',
    createdBy: '',
    province: '',
    channelId: '',
    filterCriteria: '',
    startDate: '',
    endDate: ''
  });
  const ORDER_PER_PAGE = 30;

  const {
    pendingValidation,
    waitingOnCredit,
    waitingOnSales,
    contractSigned,
    contractSent,
    orderCanceled,
    contractExpired,
    orderInstalled,
    orderPlaced,
    orderActivated,
    orderShipped,
    orderCompleted
  } = orderStatus;

  const getPayload = () => {
    const payload = {
      ...filters,
      pageNumber,
      pageSize: ORDER_PER_PAGE,
      type: 'IOT',
      status: filters.status || [
        pendingValidation,
        waitingOnCredit,
        waitingOnSales,
        contractSigned,
        contractSent,
        orderCanceled,
        contractExpired,
        orderInstalled,
        orderPlaced,
        orderActivated,
        orderShipped,
        orderCompleted
      ]
    };

    if (filters.assignedUserId)
      payload.assignedUserId = _.get(filters, 'assignedUserId.0.id');
    if (filters.createdBy) payload.createdBy = _.get(filters, 'createdBy.0.id');
    if (filters.province)
      payload.province = filters.province.map(row => row.value);
    if (filters.channelId)
      payload.channelId = filters.channelId.map(row => row.value);
    if (filters.startDate)
      payload.startDate = getFormattedDate(filters.startDate);
    if (filters.endDate) payload.endDate = getFormattedDate(filters.endDate);

    return payload;
  };

  const setOrders = data => {
    setOrdersList(_.get(data, 'data.results', []));
    setTotalOrders(_.get(data, 'data.totalCount', 0));
  };

  const fetchOrders = () => {
    setPageLoading(true);
    request
      .post('/orders/filter', getPayload())
      .then(response => {
        setOrders(response);
        setPageLoading(false);
      })
      .catch(() => {
        setPageLoading(false);
      });
  };

  useEffect(() => {
    fetchOrders();
  }, [pageNumber]);

  return (
    <>
      <DimpleDivider />
      <ContentWrapper style={{ maxWidth: '92%', margin: '0 auto', padding: 0 }}>
        <Box>
          <Analytics />
          <Filters
            setOrders={setOrders}
            filters={filters}
            setFilters={setFilters}
            getPayload={getPayload}
            includeIncompleteStatus={false}
          />
          <DimpleDivider />
          <SearchBar setOrders={setOrders} fetchOrders={fetchOrders} />
          <>
            {pageLoading ? (
              <Spinner spinning label="Loading Orders..." />
            ) : (
              <>
                {!pageLoading && ordersList.length === 0 ? (
                  <Heading level="h3">{noOrders}</Heading>
                ) : (
                  <div>
                    <TopbarWrapper style={{ color: '#fff', fontWeight: '900' }}>
                      Orders {`(${totalOrders})`}
                    </TopbarWrapper>
                    <Table data={ordersList} fetchOrders={fetchOrders} />
                    <DimpleDivider />
                    <Pagination
                      ordersPerPage={ORDER_PER_PAGE}
                      totalOrders={totalOrders}
                      pageNumber={pageNumber}
                      setPageNumber={setPageNumber}
                    />
                    <ExportReport getPayload={getPayload} />
                  </div>
                )}
              </>
            )}
          </>
        </Box>
      </ContentWrapper>
    </>
  );
};

export default IotOrderFulfillmentDashboard;
